import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { t } from 'i18next';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { memo } from 'react';
import moment from 'moment/moment';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import useFormSubmit from 'hooks/useFormSubmit';
import SimpleDateField from 'components/ui/simple-fields/date-picker/SimpleDateField';

const validationSchema = yup.object({
  valute: yup.string().required(),
  date: yup.string().required(),
  price: yup.string().required(),
});

export default memo(function AddEdit({
  open,
  setOpen,
  refetch,
  selected,
  setSelected,
}) {
  const { submit, isSubmitting } = useFormSubmit();

  const handleClose = () => {
    setOpen(false);
    setSelected({});
  };
  const handleFinishRequest = () => {
    refetch();
    handleClose();
  };

  const formik = useFormik({
    initialValues: {
      valute: null,
      date: moment().startOf('month').format('YYYY-MM-DD'),
      price: null,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const data = {
        ...values,
        date: moment(values.date, 'YYYY-MM-DD')
          .startOf('month')
          .format('YYYY-MM-DD'),
      };
      if (selected?.id) {
        submit(
          { type: 'postUpdate', contentType: 'formData' },
          data,
          '/admin/expense-marketing',
          'Marketing xarajati',
          selected?.id,
          false,
          handleFinishRequest
        );
      } else
        submit(
          { type: 'post', contentType: 'formData' },
          data,
          '/admin/expense-marketing',
          'Marketing xarajati',
          null,
          false,
          handleFinishRequest
        );
    },
  });

  const handleDate = (value) => {
    formik.setFieldValue(
      'date',
      moment(value).startOf('month').format('YYYY-MM-DD'),
      true
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{ className: '!base-border !shadow-none' }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!py-3 text-center !bg-gray-100 !mb-4 !min-w-[620px]'
      >
        <span className='pr-5 text-base'>
          {t('settings.expenseMarketing.addModal.title')}
        </span>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} sm={12} xs={12}>
              <SimpleDateField
                delay={0}
                duration={0}
                label=''
                name='date'
                openTo='month'
                views={['year', 'month']}
                inputFormat='MMMM, yyyy'
                value={formik.values.date}
                setValue={handleDate}
              />
            </Grid>
            <Grid item={true} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={`${t('common.fields.paymentAmount')} $`}
                fieldName='price'
                formik={formik}
                decimalScale={1}
              />
            </Grid>
            <Grid item={true} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={t('common.fields.valutaPrice')}
                fieldName='valute'
                formik={formik}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.3}
                duration={0}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
});
